import React, { ReactNode } from "react"
import { Container } from "reactstrap"
import LoadingState from "Components/organisms/loading-state"
import DetailPageHeader from "Components/molecule/cards/detail-page-header"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import Client from "models/client"
import Breadcrumb from "Components/organisms/breadcrumb"
import ActionButton from "Components/atoms/buttons/action-button"
import { AddressUI } from "models/address"
import { HelpIcon } from "Components/atoms/icons"

interface ClientDetailsTemplateProps {
    client: Client | null
    isLoadingClient: boolean
    sections: { title: string, content: ReactNode }[]
    handleBack: () => any
    handleOpenHelpDocument?: () => any
}

const ClientDetailsTemplate = ({
    client,
    isLoadingClient,
    sections,
    handleBack,
    handleOpenHelpDocument
}: ClientDetailsTemplateProps) => {
    return <div className="page-content">
        <Container fluid style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Breadcrumb
                title={"Business Development"}
                breadcrumbItem={"Client Details"}
                actions={<>
                    <ActionButton onClick={handleBack}>Back</ActionButton>
                    {handleOpenHelpDocument && (
                        <ActionButton onClick={handleOpenHelpDocument}>
                            Help <HelpIcon />
                        </ActionButton>
                    )}
                </>}
            />
            {
                isLoadingClient || !client ?
                    <div className="section-container">
                        <LoadingState
                            title="Loading Client"
                            subtitle="Fetching client details..."
                        />
                    </div>
                    :
                    <>
                        <DetailPageHeader
                            title={client?.name || "-"}
                            rows={[
                                {
                                    label: "Address",
                                    value: AddressUI.build(client?.address)
                                },
                            ]}

                        />
                        {sections.map(({ title, content }) => (
                            <div className="section-container" key={title}>
                                <h4>{title}</h4>
                                {content}
                            </div>
                        ))}
                    </>
            }
        </Container>
    </div>
}

export default ClientDetailsTemplate
